// src/private/DeckPileButton.jsx
import React from "react";
import { useViewport } from "react-flow-renderer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import Callout from "./Callout";
import { useT } from "../i18n/LanguageContext";
import "./DeckPileButton.css";

// Reveal button anchored to the face-down pile. Tracks pan/zoom via useViewport so it
// stays glued to the pile, at constant screen size. Shown only while the deck is hidden.
export default function DeckPileButton({ visible, onReveal, showHint }) {
  const { x, y, zoom } = useViewport();
  const t = useT();
  if (!visible) return null;
  const left = (90 + 100) * zoom + x;   // pile center-ish, flow → screen
  const top = (150 + 200) * zoom + y;
  return (
    <div className="deck-reveal-wrap" style={{ left, top }}>
      <button className="deck-reveal" onClick={onReveal}>
        <FontAwesomeIcon icon={faWandMagicSparkles} /> {t('canvas.deckPile.reveal')}
      </button>
      {showHint && (
        <Callout className="deck-reveal__hint" text={t('canvas.deckPile.hint')} />
      )}
    </div>
  );
}
